<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>404 - Seite nicht gefunden</h4>
    </div>
  </div>

  <mat-card>
    Die gewünschte Seite ist nicht verfügbar. <br />
    Klicken sie <a href="https://www.ktbl.de/webanwendungen">hier</a>, um auf
    die Web-Anwendungen vom KTBL zu gelangen.
  </mat-card>

  <div class="spacer"></div>
</div>
